var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"clearable":"","items":_vm.itemsKartTipi,"item-text":"name","item-value":"value","label":_vm.$t('Card-Type'),"hide-details":""},model:{value:(_vm.kartTipi),callback:function ($$v) {_vm.kartTipi=$$v},expression:"kartTipi"}})
}
var staticRenderFns = []

export { render, staticRenderFns }